// import React from "react";
// import { Radio, Space, Card } from "antd";
// import {
//   DollarOutlined,
//   CreditCardOutlined,
//   WalletOutlined,
// } from "@ant-design/icons";
// import "./PaymentMethod.css";

// const PaymentMethod = ({ selectedMethod, onMethodChange }) => {
//   return (
//     <div className="payment-method">
//       <Radio.Group
//         value={selectedMethod}
//         onChange={(e) => onMethodChange(e.target.value)}
//         className="payment-options"
//       >
//         <Space direction="vertical" style={{ width: "100%" }} size="large">
//           <Card
//             className={`payment-card ${
//               selectedMethod === "cod" ? "selected" : ""
//             }`}
//             onClick={() => onMethodChange("cod")}
//           >
//             <Radio value="cod">
//               <div className="payment-option">
//                 <DollarOutlined className="payment-icon" />
//                 <div className="payment-info">
//                   <h3>Cash on Delivery</h3>
//                   <p>Pay when you receive your order</p>
//                 </div>
//               </div>
//             </Radio>
//           </Card>

//           <Card
//             className={`payment-card ${
//               selectedMethod === "online" ? "selected" : ""
//             }`}
//             onClick={() => onMethodChange("online")}
//           >
//             <Radio value="online">
//               <div className="payment-option">
//                 <CreditCardOutlined className="payment-icon" />
//                 <div className="payment-info">
//                   <h3>Pay Online</h3>
//                   <p>Credit/Debit Card, UPI, Net Banking</p>
//                 </div>
//               </div>
//             </Radio>
//           </Card>
//         </Space>
//       </Radio.Group>
//     </div>
//   );
// };

// export default PaymentMethod;
import React, { useState, useEffect } from "react";
import { Radio, Space, Card, Spin } from "antd";
import { DollarOutlined, CreditCardOutlined } from "@ant-design/icons";
import settingService from "../../services/settingService";
import "./PaymentMethod.css";

const PaymentMethod = ({ selectedMethod, onMethodChange }) => {
  const [codEnabled, setCodEnabled] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      setLoading(true);
      const response = await settingService.getSettings();

      if (response?.success) {
        setCodEnabled(response.data.codEnabled);

        // If COD disabled and selected, switch to online
        if (!response.data.codEnabled && selectedMethod === "cod") {
          onMethodChange("online");
        }
      }
    } catch (error) {
      console.error("Error fetching settings:", error);
      setCodEnabled(false);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div
        className="payment-method"
        style={{ textAlign: "center", padding: "20px" }}
      >
        <Spin tip="Loading payment methods..." />
      </div>
    );
  }

  return (
    <div className="payment-method">
      <Radio.Group
        value={selectedMethod}
        onChange={(e) => onMethodChange(e.target.value)}
        className="payment-options"
      >
        <Space direction="vertical" style={{ width: "100%" }} size="large">
          {codEnabled && (
            <Card
              className={`payment-card ${
                selectedMethod === "cod" ? "selected" : ""
              }`}
              onClick={() => onMethodChange("cod")}
            >
              <Radio value="cod">
                <div className="payment-option">
                  <DollarOutlined className="payment-icon" />
                  <div className="payment-info">
                    <h3>Cash on Delivery</h3>
                    <p>Pay when you receive your order</p>
                  </div>
                </div>
              </Radio>
            </Card>
          )}

          <Card
            className={`payment-card ${
              selectedMethod === "online" ? "selected" : ""
            }`}
            onClick={() => onMethodChange("online")}
          >
            <Radio value="online">
              <div className="payment-option">
                <CreditCardOutlined className="payment-icon" />
                <div className="payment-info">
                  <h3>Pay Online</h3>
                  <p>Credit/Debit Card, UPI, Net Banking</p>
                </div>
              </div>
            </Radio>
          </Card>
        </Space>
      </Radio.Group>
    </div>
  );
};

export default PaymentMethod;
